import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { formField } from 'types';

export default ({ dcId, id }) => (
  <Shared.forms.Form
    fields={[formField.nic({ name: 'nicId', title: 'Select a Nic' })]}
    onSubmit={({ nicId }) => actions.loadbalancer.attachNic({ dcId, id, nicId })}
    isCancel={false}
    validations={[{ name: 'nicId', type: VALIDATION.REQUIRED }]}
  />
);
